import { VIEW } from "view/views";

const OPERATOR = {
  "/overview": true,
  "/devices": true,
  [`/devices/${VIEW.CREATE}`]: true,
  "/devices/config/generate": true,
  "/devices/config/import": true,
  "/devices/bulk-registration": true,
  "/devices/bulk-edit": true,
  "/devices/upgrade": true,
  "/devices/upgrade-firmware": true,
  "/devices/delete": true,
  "/strategies": true,
  [`/strategies/${VIEW.CREATE}`]: false,
  "/strategies/deploy": true,
  "/strategies/deployments": true,
  "/strategies/scheduled": false,
  "/applications": true,
  "/applications/upload": false,
  "/applications/store": true,
  "/networks": true,
  [`/networks/${VIEW.CREATE}`]: false,
  "/events": true,
  "/events/deploy": true,
  "/events/account": true,
  "/diagnostics": true,
  "/diagnostics/alerts": true,
  [`/diagnostics/alerts/${VIEW.CREATE}`]: true,
  "/diagnostics/incidents": true,
  "/alerts": true,
  [`/alerts/${VIEW.CREATE}`]: false,
  "/users": false,
  [`/users/${VIEW.CREATE}`]: false,
  "/download": true,
  "/reports": true,
  "/reports/applications": true,
  "/reports/ad-delivery": true,
};

const READONLY = {
  "/overview": true,
  "/devices": true,
  [`/devices/${VIEW.CREATE}`]: false,
  "/devices/bulk-registration": false,
  "/devices/bulk-edit": false,
  "/devices/config/generate": true,
  "/devices/config/import": false,
  "/devices/upgrade": false,
  "/devices/upgrade-firmware": false,
  "/devices/delete": false,
  "/diagnostics": true,
  "/diagnostics/alerts": true,
  [`/diagnostics/alerts/${VIEW.CREATE}`]: false,
  "/diagnostics/incidents": true,
  "/strategies": true,
  [`/strategies/${VIEW.CREATE}`]: false,
  "/strategies/deploy": false,
  "/strategies/deployments": true,
  "/strategies/scheduled": false,
  "/applications": true,
  "/applications/upload": false,
  "/applications/store": true,
  "/networks": true,
  [`/networks/${VIEW.CREATE}`]: false,
  "/events": true,
  "/events/deploy": true,
  "/events/account": true,
  "/events/v3": true,
  "/alerts": true,
  [`/alerts/${VIEW.CREATE}`]: false,
  "/users": false,
  [`/users/${VIEW.CREATE}`]: false,
  "/download": true,
  "/reports": true,
  "/reports/applications": true,
  "/reports/ad-delivery": true,
};

const ADMIN_OPERATOR = {
  "/users": false,
  [`/users/${VIEW.CREATE}`]: false,
};

const BETA_ROUTES = ["/beta"];

// This class is a util to evaluate if a user has visibility into
// certain nav items, not a real 'Permissions' checking. To evaluate user's
// access level, please utilize src/redux-store/users/permissions.js.
class Permissions {
  static isHidden(user, path) {
    if (!user) {
      return true;
    }

    if (user.disabled) {
      return true;
    }

    // TODO(syadav): As we add more routes to BETA_ROUTES,
    // we may have to add regex matching to handle query params in the URL.
    if (!this.isInternal(user) && BETA_ROUTES.includes(path)) {
      return true;
    }

    const role = user.role;

    if (role === "W") {
      return false;
    }

    if (role === "A") {
      if (path in ADMIN_OPERATOR) {
        return !ADMIN_OPERATOR[path];
      }
      return false;
    }

    if (role === "O") {
      if (path in OPERATOR) {
        return !OPERATOR[path];
      }

      return true;
    }

    if (role === "R") {
      if (path in READONLY) {
        return !READONLY[path];
      }
    }

    return true;
  }

  static isInternal(user) {
    const { email } = user;
    return email && email.includes("@vistarmedia.com");
  }
}

export { Permissions };
